import React, { Fragment,useState,useContext, useEffect, useRef } from "react";
import { useLocalStorage } from '_context/commonHooks';

import AsyncSelect from 'react-select/async';
import Select, { components,createFilter } from 'react-select';

import { getItem } from '_services/agent';
import { MapContext } from '_context/MapContext';



const selStyles = {
  option: (styles, state) => ({
    ...styles,
    color: state.isSelected ? "#333" : '#777',
    "&:hover": {
      color: "#333",
      backgroundColor: "#eee"
    }
  }),
  control: (base, state) => ({
    ...base,
    //flex:1,
    boxShadow: state.isFocused ? 0 : 0,
    borderColor: '#fff',
    '&:hover': {
      borderColor:'#fff',
    }
  }),
  menuList: (provided, state) => ({
    ...provided,
    minHeight:'424px'
  }),
};

const menuHeaderStyle = {
  padding: '8px 12px 8px 160px',
};

const Search = (props) => {
    const [value, setValue] = useState("");
    const [inputValue, setInputValue] = useState("");
    const [isOpen,setIsOpen] = useState(false);
    //const [history,setHistory] = useLocalStorage('GIS_HistoryList',window.localStorage.getItem('GIS_HistoryList') || []);
    const {history, setHistory} = useContext(MapContext);
   // const [arrData, setArrData] = useState([]);
   const selectRef = useRef()
   const onSearch = props.onSearch

    useEffect(() => {
      if(props.update){
        let now = new Date().getTime();
        setHistory({"name":props.update.name, "point":props.update.point, "timestamp":now})
      }    
    }, [props.update]);

    const onChange = (e, { action }) => {
      if(action==="select-option"){
        props.onSearch(e.label);
        setValue(e.label)
      }else if(action==="clear"){
        props.onSearch("");
        setValue("")
      }
    }

    const handleFocus = (event) => {
      const selectedOption = value;
      console.log("focus",value)
      if (selectedOption) {
        setValue(value)
      }
    };


    const loadOptions = (inputValue, callback) => {

      getItem('autocomplete','',{
        point: {lat: 37.570026282477116, lng: 126.97714803962387},
        terms: inputValue,
     }).then(res => {
              let serverData = res.data.suggests;
              const opts = serverData.map((item) => ({value:item.terms,label:item.terms}));
              //setArrData(serverData);
              // if(opts.length<10){
              //   let max = 10-opts.length
              //   for(let i=0; i<max; i++){
              //     opts.push({value:' ',label:' '})
              //   }
              // }
              callback(opts);
          }).catch(err => {

              }
          );

    };

    const onKeyDown = event => {
      if (event.keyCode === 13) {
        event.stopPropagation();
        event.preventDefault();
        selectRef.current.setState({menuIsOpen: false})
        selectRef.current.blur()
        props.onSearch(value);
      }
    };

    const chgAuto = () => {
      console.log("change auto mode")
    }

    const menuItem = (ppp) => {
      return(
        <div style={{width:200, height:30}}>{ppp.props.data.label}</div>
      )
      
    }

    const MenuList = (props) => {
      return (
        <components.MenuList {...props}>
          {props.children}
          {/* <div style={menuHeaderStyle}>
          <button className="btnOff" onClick={chgAuto}><span>자동완성 끄기</span> <span className="btnsBg"></span></button>
          </div> */}
        </components.MenuList>
        // <components.MenuList {...props}>
        //   {props.children.map((ppp,i)=> {
        //     return (
        //       <div style={{}} onClick={(e)=>{onSearch(ppp.props.data.label); setValue(ppp.props.data.label)}}>
        //         {ppp.props.data.label}
        //         <div style={{float:'right', right:10}}><bitton>삭제</bitton></div>
        //       </div>
        //     )
        //   })}
        // </components.MenuList>
        
      );
    };

    
  const handleSearchInput = (e, { action }) => {
    if (
      action === "menu-close" ||
      action === "input-blur" ||
      action === "set-value"
    ) {
      return;
    } else {
      if(e===""){
        props.onSearch("");
      }
      setValue(e)
    }
  };

/* 
  const filterOptions = (candidate, input) => {
    console.log(candidate, input,arrData)
    if (input) {
      return candidate.value === arrData[0].terms;
    }
    return true;
  }; */

    return (
      <>
      <AsyncSelect ref={selectRef}
      //  cacheOptions
        loadOptions={loadOptions}
        defaultOptions={history.map((item) => ({value:item.name,label:item.name}))} /* true이면 selbox클릭순간 loadoptions즉시실행하여 초기값 가져오고, 초기 데이터 넣으면 필터링할때만 loadoptions실행 */
        className="selSearch-container"
        classNamePrefix="selSearch"
        styles={selStyles}
        placeholder={'검색어를 입력하세요'}
        components={{ DropdownIndicator:() => null, IndicatorSeparator:() => null, MenuList }}
        noOptionsMessage={() => null}
        isClearable = {true}
        // onFocus={handleFocus}
        value={value?{"value":value,"label":value}:null}
        inputValue={value}
        onKeyDown={onKeyDown}
        onChange={(e,action)=>onChange(e,action)}
        onInputChange={(e,action)=>handleSearchInput(e,action)}
        //  filterOption={createFilter({
        //   matchFrom: 'any',
        //   stringify: option => `${option.label}`,
        // })}  
        //filterOption={(option, filter)=>{ return (filter.length % 3) === 0 ? true : false }}
      // filterOption={filterOptions}
    />
    <button className="btnsBg btnFind" title="검색" onClick={()=>props.onSearch(value)}>검색</button>
    </>
    );
  };
  
  export default Search;